// The back office's email check and its two messages, in one place (legacy `common.emailErrorMessage` and
// `common.emailInvalidErrorMessage`). Legacy read "Please type a email" and "Please enter an valid email"; Next fixes the
// articles (Q-EMP-06, bug B594, ledger L750).

/** Legacy's email pattern: something, an @, something, a dot, something; no spaces. */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EMAIL_REQUIRED = 'Please type an email';
export const EMAIL_INVALID = 'Please enter a valid email';

/** The message for a required email field, or undefined when it is fine. The value is checked as typed. */
export function emailError(email: string): string | undefined {
  if (email === '') return EMAIL_REQUIRED;
  return EMAIL_PATTERN.test(email) ? undefined : EMAIL_INVALID;
}

/** `{ email: message }` for a form's errors, or nothing when the email is fine. */
export function emailErrors(email: string): { readonly email?: string } {
  const message = emailError(email);
  return message === undefined ? {} : { email: message };
}
